import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=80e2a94a&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "./Notice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80e2a94a')) {
      api.createRecord('80e2a94a', component.options)
    } else {
      api.reload('80e2a94a', component.options)
    }
    module.hot.accept("./Notice.vue?vue&type=template&id=80e2a94a&", function () {
      api.rerender('80e2a94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/Notice.vue"
export default component.exports